import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { JournalEntrySourceType } from "@common/schemas/domains/accounting/journalEntry";
import { GLTableMeta, GLViewRow } from "../glViewTypes";

export const GL_COPY_LABEL = "Journal Entry";

export const CLICKABLE_SOURCE_TYPES = new Set([
    JournalEntrySourceType.Transaction,
    JournalEntrySourceType.Bill,
    JournalEntrySourceType.Invoice,
]);

export function getGLTableMeta(
    table: CellContext<ViewTableFeatures, GLViewRow, unknown>["table"],
): GLTableMeta | undefined {
    return table.options.meta as GLTableMeta | undefined;
}
